import Modal from 'components/Modal';
import Text from 'components/Text';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';
type IModalWarningProps = {};
type IModalWarningConfigs = {
  message: string;
  okTitle?: string;
};

type IModalWarningRef = {
  open: (config: IModalWarningConfigs) => void;
  close: () => void;
};
export const ModalWarningRef = React.createRef<IModalWarningRef>();
const ModalWarningContext = forwardRef<IModalWarningRef, IModalWarningProps>((props, ref) => {
  const [open, setOpen] = useState(false);
  const [config, setConfig] = useState<IModalWarningConfigs | null>(null);
  const handleOpen: IModalWarningRef['open'] = (_config) => {
    setOpen(true);
    setConfig(_config);
  };

  const handleClose: IModalWarningRef['close'] = () => {
    setOpen(false);
  };

  useImperativeHandle(ref, () => ({
    open: handleOpen,
    close: handleClose,
  }));

  return (
    <Modal
      visible={open}
      onClose={handleClose}
      hiddenHeader
      okTitle={config?.okTitle || 'Ok'}
      onSubmit={handleClose}
      hiddenOkButton
      zIndex={10000}
      v2
      width={700}
      noneBodyStyle
      noneFooterStyle
      containerPadding={2}
      cancelTitle={config?.okTitle || 'Ok'}
    >
      <ModalStyled>
        <IconWarningBig />
        <Text className='innerHtml' variant='H7' mt={2} mb={1} style={{ fontSize: '1.5rem' }}>
          <div dangerouslySetInnerHTML={{ __html: config?.message || '--' }} />
        </Text>
      </ModalStyled>
    </Modal>
  );
});

ModalWarningContext.displayName = 'ModalWarningContext';
const ModalWarning = {
  Portal: () => <ModalWarningContext ref={ModalWarningRef} />,
  open: ((configs) => {
    ModalWarningRef.current?.open(configs);
  }) as IModalWarningRef['open'],
  close: () => {
    ModalWarningRef.current?.close();
  },
};

export default ModalWarning;

const ModalStyled = styled.div`
  text-align: center;
  .innerHtml {
    b {
      color: #6FABB6;
    }
  }
`;

const IconWarningBig = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="97" height="96" viewBox="0 0 97 96" fill="none">
    <path d="M47.1016 0.0228096C55.1129 -0.22689 63.1789 1.57766 70.3131 5.23293C80.7502 10.506 89.0973 19.7575 93.2729 30.6813C96.9722 40.1783 97.5136 50.865 94.7963 60.6872C92.5469 68.9693 88.0082 76.6156 81.8203 82.5622C75.9639 88.2318 68.624 92.355 60.7385 94.4198C51.8584 96.7699 42.2985 96.4971 33.5758 93.6119C23.9194 90.4917 15.3351 84.1821 9.45146 75.9147C5.22546 70.0184 2.37175 63.1465 1.17361 55.9933C-0.943594 43.7496 1.96467 30.7359 9.10944 20.5716C14.9679 12.1091 23.6382 5.6421 33.4163 2.43168C37.8291 0.975446 42.4538 0.14661 47.1016 0.0228096ZM46.4909 13.7206C44.5878 14.1676 42.8441 15.2692 41.6312 16.803C40.2296 18.5363 39.556 20.8171 39.7428 23.0329C40.6178 34.8842 41.4991 46.7355 42.3741 58.5868C42.4223 59.0841 42.4013 59.5982 42.544 60.085C42.7161 60.5299 43.2155 60.7292 43.6687 60.6914C46.961 60.683 50.2532 60.6998 53.5434 60.683C54.1393 60.7124 54.5883 60.1459 54.5611 59.5793C55.4654 47.3294 56.3824 35.0794 57.2784 22.8294C57.4756 19.9694 56.1642 17.0632 53.8833 15.3237C51.827 13.7122 49.0299 13.1121 46.4909 13.7206ZM46.7218 68.2957C45.2278 68.6671 43.868 69.5316 42.8923 70.7193C40.7521 73.2268 40.6933 77.2031 42.7601 79.7714C44.7682 82.4594 48.7319 83.3679 51.7095 81.8215C54.9493 80.2939 56.6027 76.1812 55.2955 72.8386C54.133 69.433 50.1945 67.3389 46.7218 68.2957Z" fill="#FFDC7C" />
  </svg>
);
